import axios from 'axios';
import {
  SCHOOL_PORTAL_ERROR_CODES,
  SCHOOL_PORTAL_EVENT,
  SCHOOL_PORTAL_SESSION_KEYS,
} from '../constants/schoolPortal';

// Use relative /api so dev proxy works (proxy target = backend). Set REACT_APP_API_URL for absolute URL (e.g. production).
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      const code = error.response?.data?.code;
      const message = error.response?.data?.message || 'Access denied.';
      if (code === SCHOOL_PORTAL_ERROR_CODES.SCHOOL_BLOCKED) {
        try {
          sessionStorage.setItem(
            SCHOOL_PORTAL_SESSION_KEYS.LOGIN_NOTICE,
            JSON.stringify({ message })
          );
        } catch (_) {
          /* ignore */
        }
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
        return Promise.reject(error);
      }
      if (code === SCHOOL_PORTAL_ERROR_CODES.SCHOOL_INACTIVE) {
        try {
          window.dispatchEvent(
            new CustomEvent(SCHOOL_PORTAL_EVENT.API_FORBIDDEN, {
              detail: { message, severity: 'warning' },
            })
          );
        } catch (_) {
          /* ignore */
        }
      }
    }
    if (error.response?.status === 401) {
      const isAuthEndpoint = error.config?.url?.includes('/auth/otp/') || error.config?.url?.includes('/auth/login/');
      if (!isAuthEndpoint) {
        // Unauthorized on protected route - clear token and redirect to login
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
